import UserService from 'Main/service/UserService'
import { useEffect, useMemo, useState } from 'react'

function useLogUserFilter () {
  const userService = useMemo(() => new UserService(), [])
  const [isSuperAdmin, setIsSuperAdmin] = useState(false)
  const [users, setUsers] = useState([])
  const [loadingUsers, setLoadingUsers] = useState(true)

  useEffect(() => {
    let active = true

    const load = async () => {
      try {
        const profileResponse = await userService.getUser()
        const superAdmin = String(profileResponse?.data?.type || '').toUpperCase() === 'SUPERADMIN'
        if (!active) return

        setIsSuperAdmin(superAdmin)
        if (!superAdmin) return

        const usersResponse = await userService.getUsers()
        if (!active) return

        const rows = Array.isArray(usersResponse?.data) ? usersResponse.data : []
        setUsers([...rows].sort((left, right) => {
          const leftLabel = String(left.name || left.email || left.id)
          const rightLabel = String(right.name || right.email || right.id)
          return leftLabel.localeCompare(rightLabel)
        }))
      } catch {
        if (active) {
          setIsSuperAdmin(false)
          setUsers([])
        }
      } finally {
        if (active) setLoadingUsers(false)
      }
    }

    load()
    return () => { active = false }
  }, [userService])

  return { isSuperAdmin, users, loadingUsers }
}

export default useLogUserFilter
